import { defineProductDimensions, nlAovqlPricingVersionDimension, nlAovqlSelectedDimension } from '@orus.eu/dimensions'

import { nlAovqlProductVersionDimension } from './nl-aovql-dimensions.ts'
import { nlAovqlQuoteDimension } from './nl-aovql-quote-dimension.ts'

export * from './nl-aovql-activity-dimensions.ts'
export * from './nl-aovql-cover-end-age-dimension.ts'
export * from './nl-aovql-crossed-out-price-dimension.ts'
export * from './nl-aovql-dimensions.ts'
export * from './nl-aovql-estimated-price-after-tax-deduction-dimension.ts'
export * from './nl-aovql-fee-dimensions.ts'
export * from './nl-aovql-health-declaration-outcome-dimension.ts'
export * from './nl-aovql-knowledge-test-outcome-dimension.ts'
export * from './nl-aovql-policy-item-dimension.ts'
export * from './nl-aovql-quote-dimension.ts'
export * from './nl-aovql-subscription-ui.ts'
export * from './nl-aovql-ui-elements.ts'

export const nlAovqlDimensionsModule = defineProductDimensions({
  product: 'nl-aovql',
  family: null,
  selectionDimension: nlAovqlSelectedDimension,
  productVersionDimension: nlAovqlProductVersionDimension,
  pricingVersionDimension: nlAovqlPricingVersionDimension,
  quoteV3Dimension: nlAovqlQuoteDimension,
})
